module.exports = __webpack_public_path__ + "media/img/frontend_application/down-icon-d0c3b35a35113d3b0b9ff756ccd36f5e.svg";